const stopTranscribingRef = { current: null };

export const registerStopTranscribing = (fn) => {
  stopTranscribingRef.current = fn;
};

export const stopTranscribing = () => {
  if (stopTranscribingRef.current) {
    stopTranscribingRef.current();
  }
};
